<template>
  <v-layout>
      <v-flex>                    
        <v-data-table
        :headers="headers"
        :items="puertos"        
        :search="search"
        class="elevation-1"
        >
        <template v-slot:item.activo="{ item }">  
            <div v-if="item.activo  ">
                <span class="blue--text">Activo</span>
                
            </div>
            <div v-else>
                <span class="red--text">Inactivo</span>                
            </div>                  
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Industry</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer> 
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                    </template>
                    <v-card>
                    <v-card-title>
                        <span class="headline" style="color: #1f6aa5;font-weight: 500;">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="nombre" label="Name"></v-text-field>
                                </v-col>                                                               
                                <v-col cols="12" sm="12" md="12" v-show="valida">
                                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v"></div>
                                </v-col>                                                        
                            </v-row>
                        </v-container>
                    </v-card-text>    
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="guardar">Save</v-btn>
                    </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog  v-model="adModal" max-width="290px">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activate Industry?</v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Disable Industry?</v-card-title>
                        <v-card-text>
                            You are about to
                            <span v-if="adAccion==1">Activate</span>
                            <span v-if="adAccion==2">Disable</span>
                            the item {{ adNombre }}
                        </v-card-text>
                        <v-card-actions>
                             <v-spacer></v-spacer>
                             <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                 Cancel
                             </v-btn>
                             <v-btn v-if="adAccion==1" color="orange darken1" text="text" @click="activar">
                                 Accept
                             </v-btn>
                             <v-btn v-if="adAccion==2" color="orange darken1" text="text" @click="desactivar">
                                 Disable
                             </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
        </template>
        <template v-slot:item.opciones="{ item }">
            <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            >
            edit
            </v-icon>
            <template v-if="item.activo">                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(2,item)"
                    >
                    block
                    </v-icon>                               
            </template>
            <template v-else>                         
                   <v-icon
                    small
                    @click="activarDesactivarMostrar(1,item)"
                    >
                    check
                    </v-icon>                               
            </template> 
        </template>   
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template>     
        </v-data-table>                        
      </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'      
export default {
    data(){
        return{
            puertos:[], 
             adModal:false,            
             dialog: false,
                headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },                            
                { text: 'Name', value: 'nombre' },
                { text: 'Estado', value: 'activo' },                                          
                ],
                search:'',
                editedIndex: -1,              
                id:'',
                idpais:'',
                idpuerto:'',
                paises:[],
                codigo:'',
                nombre:'',
                descripcion:'',                
                valida:'',
                validaMensaje:[],                
                adAccion:0,
                adNombre:'',
                adId:''
                
        }
    },
    computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'New Industry' : 'Update Industry'
        },
    },

    watch: {
        dialog (val) {
            val || this.close()
        },        
    },

    created () {        
        this.listar();
    },
    methods:{        
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Industrias/Listar',configuracion).then(function(response){
              //console.log(response);
              me.puertos=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },

        editItem (item) {
            this.id=item.idindustria;                
            this.nombre=item.nombre;                       
            this.editedIndex=1;
            this.dialog = true
        },
       

        close () {
            this.dialog = false;            
            this.limpiar();
        },
        limpiar(){
            this.id="";
            this.nombre="";
            this.descripcion="";
            this.idpuerto="";
            this.codigo="";            
            this.editedIndex=-1;
        },
        guardar () {
            if(this.validar()){
                return;
            }
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            
            if (this.editedIndex > -1) {//codigo para editar            
                let me=this;                
                axios.put('api/Industrias/Actualizar',{
                    'idindustria':me.id,                    
                    'nombre':me.nombre,
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });  
            }else{//codigo para guardar
                let me=this;
                axios.post('api/Industrias/Crear',{
                    'nombre':me.nombre,
                },configuracion).then(function(response){
                    window.alert('Guardado correctamente')
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });                
            }            
        },
        validar(){
            this.valida=0;
            this.validaMensaje=[];

            if(this.nombre.length<3 || this.nombre.length>50){
                this.validaMensaje.push("El nombre debe tener mas de 3 caracteres y menos de 150 caracteres.");
            }        
            if(this.validaMensaje.length){
                this.valida=1;
            } 
            return this.valida;
        },
        activarDesactivarMostrar(accion,item){
           this.adModal=true;
           this.adNombre=item.nombre;
           this.adId=item.idindustria;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModal=false;
            }
        },
        activarDesactivarCerrar(){
            this.adModal=false;
        },
        activar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Industrias/Activar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            }); 
        },
        desactivar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Industrias/Desactivar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            });
        },
    }
}
</script>